import React from 'react';
import { SearchIcon, RulerIcon, FactoryIcon, GiftIcon, RefreshCwIcon } from 'lucide-react';
const POINTS = [{
  icon: SearchIcon,
  title: 'Professional weld discontinuity references',
  body: 'Access annotated defect illustrations, joint geometry diagrams, visual comparisons, NDT method explanations, and inspection identification resources.'
}, {
  icon: RulerIcon,
  title: 'Structured welding inspection workflows',
  body: 'Move from identifying joint configurations to recognizing discontinuities, measuring weld geometry, reviewing examination findings, and documenting inspection results.'
}, {
  icon: FactoryIcon,
  title: '6 specialized welding inspection areas',
  body: 'Joint analysis, discontinuity identification, visual testing, NDT methods, quality assessment, and practical field inspection organized into one comprehensive system.'
}, {
  icon: GiftIcon,
  title: '5 practical inspection bonuses',
  body: 'Field checklists, discontinuity reference cards, measurement guides, reporting templates, and realistic inspection case exercises.'
}, {
  icon: RefreshCwIcon,
  title: 'Ready to reference again and again',
  body: 'Return to the system whenever you need to compare a weld indication, review a measurement technique, understand an inspection method, or organize quality documentation.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-109" data-mp="2xov00f6o3ptz">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-110" data-mp="2xnjuoaxkqa0r">
        <h2 className="text-center text-3xl leading-none text-white sm:text-5xl" data-id="element-111" data-mp="2ss4l3v6ln0a5">
          THIS ISN'T JUST ANOTHER WELDING EBOOK
        </h2>
        <p className="mt-1 text-center font-display text-base font-bold uppercase leading-tight text-gold sm:text-2xl" data-id="element-112" data-mp="2ntkxlqccxgfo">
          IT'S A COMPLETE, READY-TO-USE VISUAL WELD INSPECTION REFERENCE SYSTEM.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-113" data-mp="18b7yoif3eudo">
          {POINTS.map((point, i) => {
          const Icon = point.icon;
          return <div key={point.title} className={`flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3 ${i === POINTS.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-114" data-mp="19q2b7mlhhugy" data-mpi={i}>
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech" aria-hidden="true" data-id="element-115" data-mp="14siumg1bd5lu" />
                <div data-id="element-116" data-mp="r1x9ekoe0jks">
                  <h3 className="text-base leading-tight text-white sm:text-lg" data-id="element-117" data-mp="r0m94uu5htyf">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-118" data-mp="vtfdhhlpj09z">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-base font-extrabold uppercase text-white sm:text-xl" data-id="element-119" data-mp="m2aywizy1hfo">
          Less scattered searching. Clearer visual identification.{' '}
          <span className="text-gold" data-id="element-120" data-mp="855n02djtoci">More organized weld inspection references.</span>
        </p>
      </div>
    </section>;
}